// ⚠️ EDITA estos datos con la información real de tus cuentas receptoras.
// Se muestran al usuario en la pantalla de pago local (Venezuela).

export const LOCAL_PAYMENT = {
  // Precio de referencia local que verá el usuario por plan (texto libre).
  // Puedes ponerlo en Bs, en USD, o dejar el equivalente. Ej: "Bs. 180" / "$4.99".
  priceHint: {
    monthly: "$4.99",
    annual: "$39.99",
  },

  // Métodos disponibles y los datos de cada cuenta (EDITAR).
  methods: [
    {
      id: "pago_movil",
      name: "Pago Móvil",
      fields: [
        { label: "Banco", value: "0000 - Banco Ejemplo" },
        { label: "Teléfono", value: "0412-0000000" },
        { label: "Cédula / RIF", value: "V-00.000.000" },
      ],
    },
    {
      id: "transferencia",
      name: "Transferencia bancaria",
      fields: [
        { label: "Banco", value: "Banco Ejemplo" },
        { label: "N.º de cuenta", value: "0000-0000-00-0000000000" },
        { label: "Titular", value: "Nombre del titular" },
        { label: "Cédula / RIF", value: "V-00.000.000" },
      ],
    },
  ],

  // Contacto opcional de soporte (WhatsApp/correo). Deja "" para ocultarlo.
  supportContact: "",
};
